import React, { Fragment } from "react";
import { IconButton } from "@mui/material";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import FirstPageIcon from '@mui/icons-material/FirstPage';

const SimplePagination = ({ prev, next, paginationOptions, handleChangePage }) => {
  return (
    <Fragment>
      <IconButton
        disabled={!prev}
        onClick={(event) =>
          handleChangePage(event, 1)
        }
        sx={{
          minWidth: '40px',
          minHeight: '40px',
          color: 'black'
        }}
        aria-label='page-back'
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        disabled={!prev}
        onClick={(event) =>
          handleChangePage(event, paginationOptions.currentPage - 1)
        }
        sx={{
          minWidth: '40px',
          minHeight: '40px',
          color: 'black'
        }}
        aria-label='page-back'
      >
        <NavigateBeforeIcon />
      </IconButton>
      <IconButton
        sx={{
          minWidth: '40px',
          minHeight: '40px',
          color: 'black',
          fontSize: '0.9375rem',
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        }}
        size='small'
        aria-label='page-number'
      >
        {paginationOptions.currentPage}
      </IconButton>
      <IconButton
        disabled={!next}
        onClick={(event) =>
          handleChangePage(event, paginationOptions.currentPage + 1)
        }
        sx={{
          minWidth: '40px',
          minHeight: '40px',
          color: 'black'
        }}
        aria-label='page-next'
      >
        <NavigateNextIcon />
      </IconButton>
    </Fragment>
  );
};

export default SimplePagination;
